import React from 'react';
import { TextFieldProps as MUITextFieldProps } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import styles from '@/components/atoms/TextField/textField.module.css';

interface AtomTextFieldProps extends Omit<MUITextFieldProps, 'variant'> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  variant?: 'outlined' | 'filled' | 'standard';
  helperText?: React.ReactNode;
  error?: boolean;
  fullWidth?: boolean;
}

const AtomTextField: React.FC<AtomTextFieldProps> = ({
  startIcon,
  endIcon,
  variant = 'outlined',
  helperText,
  error = false,
  fullWidth = true,
  className = '',
  ...props
}) => {
  const baseClassName = `${styles.atomTextField} ${className}`.trim();

  return (
    <TextField
      variant={variant}
      error={error}
      helperText={helperText}
      fullWidth={fullWidth}
      className={baseClassName}
      
      InputProps={{
        startAdornment: startIcon ? (
          <InputAdornment position="start">{startIcon}</InputAdornment>
        ) : undefined,
        endAdornment: endIcon ? (
          <InputAdornment position="end">{endIcon}</InputAdornment>
        ) : undefined,
      }}
      {...props}
    />
  );
};

export default AtomTextField;
